import store from '../store'; // 引入 Vuex store
export const globalStorage = {
    set(key, value) {
        store.commit(key, value)
    },
    get_value(fun,key) {
        let func= store.getters[fun]
        return func(key)
    }
}
